import type { LobbyCharacterInfo, PartyMemberInfo } from '@danda/shared';
import type { Character } from '@/lib/stores/lobbyStore.types';

/**
 * `member.avatarUrl` is a party-doc snapshot that goes stale the moment the
 * character regenerates their avatar (`/avatar`): the party doc isn't
 * re-synced on regen. For the CURRENT player's own selected character, the
 * live character store is always fresher and correct; prefer it first,
 * matching `PartyPanel.tsx`'s `selectedCharacter` special case. Other
 * members (no live record for an offline other-player PC) still fall back
 * to the snapshot; it's the only data available then.
 */
export function resolveParticipantAvatarUrl(
  member: Pick<PartyMemberInfo, 'avatarUrl'>,
  lobbyChar: Pick<LobbyCharacterInfo, 'avatarUrl' | 'avatar'> | undefined,
  ownChar: Character | undefined,
  isSelf: boolean
): string | undefined {
  const ownAvatar =
    ownChar?.avatarUrl ||
    ownChar?.avatar ||
    (ownChar?.permanent?.avatar_url as string | undefined) ||
    (ownChar?.permanent?.avatarUrl as string | undefined);
  return isSelf
    ? ownAvatar || member.avatarUrl || lobbyChar?.avatarUrl || lobbyChar?.avatar
    : member.avatarUrl || lobbyChar?.avatarUrl || ownAvatar || lobbyChar?.avatar;
}
